import { footerLinks, partnerSection } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-black text-white font-heading mb-3 block">
              51爆料网
            </span>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              每日吃瓜爆料第一站。汇聚全网最快最全的今日最新爆料和实时吃瓜消息，涵盖娱乐圈、网红圈、社会热点等九大板块，每日持续更新。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-weibo-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-wechat-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-share-line text-background-200 text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </div>

          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h4 className="font-bold text-white text-sm mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <h4 className="font-bold text-white text-sm mb-3">{partnerSection.title}</h4>
          <p className="text-sm text-background-500">{partnerSection.description}</p>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51爆料网 51baoliao.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}